import Vue from 'vue';
import Vuex from 'vuex';

import API from './api';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        status: '',
        vacanciesMeta: {},
        vacanciesMetaIsEmpty: true,
        vacancies: [],
        vacanciesIsEmpty: true,
        /* DISABLED
        vacancyDetails: {},
        */
        theme: 'black'
    },
    mutations: {
        setVacanciesMeta(state, data) {
            state.vacanciesMeta = data;
            state.vacanciesMetaIsEmpty = !data;
        },
        setVacancies(state, data) {
            state.vacancies = data;
            state.vacanciesIsEmpty = !data;
        },
        /* DISABLED
        setVacancyDetails(state, payload) {
            state.vacancyDetails[payload.id] = payload.data;
        },
        */
        setTheme(state, theme) {
            state.theme = theme;
        }
    },
    actions: {
        async getVacanciesMeta(context) {
            const data = await API.getMeta();
            context.commit('setVacanciesMeta', data);
        },
        async getVacancies(context) {
            const data = await API.getVacancies();
            context.commit('setVacancies', data);
        },
        /* DISABLED
        async getVacancyDetails(context, id) {
            const data = await API.getVacancy(id);
            context.commit('setVacancyDetails', {data, id});
        },
        */
        setTheme(context, theme) {
            context.commit('setTheme', theme);
        }
    }
});

export default store;
